"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unregistered_bidders_for_client = void 0;
var api_1 = require("../../../api");
var unregistered_bidders_for_client = function (req) {
    return (0, api_1.apiGet)({
        endpoint: "v3/bidder/unregistered_bidders_for_client",
        query: req,
    });
};
exports.unregistered_bidders_for_client = unregistered_bidders_for_client;
